import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import ProductCategoryApi from '../../Api/ProductCategoryApi';
import Swal from "sweetalert2";

const ProductCategoryMaster = () => {

    const [itemId, setitemId] = useState('');
    const [name, setName] = useState();


    const [data, setData] = useState([]);

    const handleSave = async () => {
        if (!String(name || "").trim()) {
            await Swal.fire({
                title: "Validation",
                text: "Product Category Name is required.",
                icon: "warning",
                width: "300px",
            });
            return;
        }

        const response = await ProductCategoryApi.CreateProductCategory(name);
        if (response.StatusCode === 201) {
            console.log("response", response);
            await Swal.fire({
                title: "Created",
                text: response?.Result?.name
                    ? `Category "${response.Result.name}" created successfully.`
                    : "Created successfully.",
                icon: "success",
                width: "300px",
            });
            setName('')
            fetchProductCatData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to create category.",
                icon: "error",
                width: "300px",
            });
        }
    }

    const handleUpdate = async () => {
        if (!String(name || "").trim()) {
            await Swal.fire({
                title: "Validation",
                text: "Product Category Name is required.",
                icon: "warning",
                width: "300px",
            });
            return;
        }

        const response = await ProductCategoryApi.UpdateProductCategory(itemId, name);
        if (response.StatusCode === 200) {
            console.log("response", response);
            await Swal.fire({
                title: "Updated",
                text: response?.Result?.name
                    ? `Category "${response.Result.name}" updated successfully.`
                    : "Updated successfully.",
                icon: "success",
                width: "300px",
            });
            setitemId('')
            setName('')
            fetchProductCatData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to update category.",
                icon: "error",
                width: "300px",
            });
        }
    }

    const handleEdit = (item) => {
        setitemId(item.id)
        setName(item.name)
        console.log(`Edit item with id ${item.id}`);
    };


    const handleDelete = async (id) => {
        const targetItem = data.find((item) => item.id === id);
        const categoryName = targetItem?.name || `ID ${id}`;

        const result = await Swal.fire({
            title: "Are you sure?",
            text: `Delete category "${categoryName}"?`,
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes delete it !!",
            width: "300px",
        });

        if (!result.isConfirmed) return;

        const response = await ProductCategoryApi.DeleteProductCategory(id);
        if (response.StatusCode === 200) {
            console.log("response", response);
            await Swal.fire({
                title: "Deleted",
                text: `Category "${categoryName}" deleted successfully.`,
                icon: "success",
                width: "300px",
            });
            setData(data.filter(item => item.id !== id));
            fetchProductCatData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to delete category.",
                icon: "error",
                width: "300px",
            });
        }
    };


    const fetchProductCatData = async () => {
        const response = await ProductCategoryApi.GetProductCategory();
        if (response) {
            console.log("response", response);
            setData(response.Result)
        }
    }

    useEffect(() => {
        fetchProductCatData()
    }, []);


    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Product Category Master</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" value={name} onChange={(e) => setName(e.target.value)} required />
                                    <label class="modify_p_text2">Product Category Name</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        {itemId ? (<button
                            id="SaveBtnMain"
                            className={`update-button-main-save hovered`}
                            onClick={handleUpdate}
                        >
                            Update
                        </button>
                        ) : (
                            <button
                                id="SaveBtnMain"
                                className={`save-button-main-save hovered`}
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>
                <div className="company_info-text-im">Product Category Master List</div>
                <div className="control_radius">
                    <div className="table-account-manager">
                        <table className='table-master-acc'>
                            <thead className='header-table-account'>
                                <tr>
                                    <th className='table-header-manager ac-sno-wth'>S.No</th>
                                    <th className='table-header-manager'>Product Category Name</th>
                                    <th className='table-header-manager'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                        <td className='table-data-account'>{item.name}</td>
                                        <td className='table-data-account'>
                                            <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                            <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductCategoryMaster;
